<script>
// Missing:
// Helios nav bar.

// To find element that is making x overflow (translate z group), use: 
// https://stackoverflow.com/questions/31458477/find-element-that-is-causing-the-showing-of-horizontal-scrollbar-in-google-chrom
// var all = document.getElementsByTagName("*"), i = 0, rect, docWidth = document.documentElement.offsetWidth;
// for (; i < all.length; i++) {
//     rect = all[i].getBoundingClientRect();
//     if (rect.right > docWidth || rect.left < 0){
//         console.log(all[i]);
//         all[i].style.borderTop = '1px solid red';
//     }
// }

  import Filters from "./components/assets/Filters.svelte";

  import TopBar from "./components/TopBar.svelte";
  import Main from "./Main.svelte";
  import Footer from "./components/Footer.svelte";

  // import VisuallyHidden from "./components/helpers/VisuallyHidden.svelte";
</script>

<!-- Global filters -->
<Filters />

<div class="app-container">
  <TopBar />
  <Main />
  <Footer />
</div>

<!-- Example Components -->

<!-- <VisuallyHidden>
  <h1>Hey there!</h1>
</VisuallyHidden> -->

<style global>
  .voila-content {
    /* Typography */
    --sans: "Montserrat", Helvetica, Arial, sans-serif;
    --condensed: "Oswald",  Helvetica, Arial, sans-serif;
    --serif: "PT Serif", Georgia, Times, serif;
    --mono: Menlo, Consolas, Monaco, "Courier New", monospace;
    /* --base-font-size: 1.1rem;
    --base-font-size-tablet: 1rem; */

    /* Layers */
    --z-bottom: 0;
    --z-middle: 50;
    --z-top: 100;
    --z-overlay: 500;

    /* Dimensions */
    --max-width: 800px;
    --text-width: 600px;

    /* Colours */
    --brand-yellow: #f3e600;

    --black: #000;
    --off-black: #282828;
    --off-black_hsl: 0, 0%, 16%;
    --grey-dark: #5b5b5b;
    --grey: #a7a8a9;
    --grey-light: #c8c9c7;
    --off-white: #f0f0f0;
    --off-white_hsl: 0, 0%, 94%;
    --white: #fff;
    --grey-faded: hsla(0, 0%, 0%, 0.03);
    --red: hsla(359, 94%, 62%, 1);
    --neutral: hsla(177, 100%, 14%, 1);
    --neutral-faded: #F5FAF8; /* hsla(160, 29%, 90%, 0.3); */
    --neutral-faded1: hsla(160, 29%, 90%, 0.6);
    --neutral-faded2: hsla(160, 29%, 90%, 0.12);
    --neutral-accent: hsla(160, 29%, 90%, 0.5);
    --neutral-muted: hsla(160, 20%, 80%, 1);
    --orange: hsla(22, 100%, 55%, 1);
    --orange-medium: hsla(22, 100%, 55%, 1);
    --orange-faded: hsla(23, 100%, 97%, 1);
    --blue: hsla(209, 39%, 41%, 1);
    --blue-faded: hsla(190, 33%, 93%, 1);
    --turquoise: hsla(162, 43%, 46%, 1);
    --turquoise-medium: hsla(162, 43%, 35%, 1);
    --turquoise-dark: hsla(162, 100%, 15%, 1);
    --turquoise-faded: hsla(156, 33%, 97%, 1);


    --dark: hsla(189, 31%, 20%, 1); /* #233e43; */

    --bg: var(--neutral-faded);
    --bg_hsl: var(--off-white_hsl);
    --bg-chart: var(--white);
    --fg: var(--off-black);

    --default: var(--dark);
    --primary: var(--grey);
    --secondary: var(--brand-yellow);

    --body-font: var(--sans);
    --text-main: var(--dark);
    --text-annotations: #fff;
    --text-axis: var(--dark);
    --links: var(--grey);
    --border: var(--dark);
    --border-standard: 1.5px solid var(--neutral);
    --axes: var(--dark);
    --shadow_hsl: var(--off-black_hsl);
    --annotations: var(--off-black);

    --padding: 16px;
    --border-curve: 8px;

    --dash_legislated: 10,8;
    --dash_developing: 4,8;
    --dash_announced: 1,8;
    --dash_announced_less: 2,6;
    /* --dash_announced_more: 0.5,7; */
    --dash_announced_more: 1,8;

    /* --dash_legislated: 10,6;
    --dash_developing: 6,10;
    --dash_announced_less: 3,13;
    --dash_announced_more: 1,7; */
  }

  /* cancelling */

  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
  /*! https://github.com/a11yproject/a11yproject.com/blob/main/src/css/base/_resets.scss */
  .voila-content * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  .voila-content img {
    border-style: none;
  }

  .voila-content img,
  .voila-content figure {
    border: 0;
    display: block;
    height: auto;
    max-width: 100%;
  }
  .voila-content {
    -webkit-text-size-adjust: 100%;
    line-height: 1.5;
    word-break: normal;
    margin: 0;
    background: var(--bg);
    color: var(--text-main);
    font-family: var(--body-font);
    text-rendering: optimizeLegibility;
    font-feature-settings: "kern" 1, "onum" 0, "liga" 0, "tnum" 1;
  }
  .voila-content h1,
  .voila-content h2,
  .voila-content h3,
  .voila-content h4,
  .voila-content h5,
  .voila-content h6 {
    margin: 1rem 0;
  }

  .voila-content p {
    margin: 1rem 0;
  }

  .voila-content a {
    background-color: transparent;
    color: inherit;
  }

  .voila-content ol {
    padding-left: 2em;
    list-style-position: outside;
  }

  .voila-content ol li {
    padding-left: 0.5em;
  }

  .voila-content ol li:not(:last-child) {
    margin-bottom: 0.5em;
  }

  html {
    font-size: 100%; 
  }

  body {
    margin: 0;
    width: 100%;
    height: 100%;
  }

  .voila-content {
    max-width: 100vw !important;
    width: 100%;
  }
</style>
